/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: package-notifications-search-view-component.ts
 *
 * Created by randysorensen on 4/9/18.
 */

function PackageNotificationsSearchViewController(
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    uiGridConstants: JS5Object,
    ModalService: JS5Object,
    NotificationService: JS5Object,
    PackageNotificationsService: JS5Object
) {

    const getData = () => {
        this.loadingIndicator.show = true;

        if (_.get(this, 'gridApi.selection')) {
            this.gridApi.selection.clearSelectedRows();
        }

        PackageNotificationsService.getPackageNotifications().then((notifications: JS5Object[]) => {
            this.gridOptions.data = notifications;
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    this.getStatusDescription = (status: string): string => PackageNotificationsService.packageStatusDictionary[status];

    const getSelectedCount = (): number => {
        let selectedCount = 0;
        if (_.get(this, 'gridApi.selection')) {
            selectedCount = this.gridApi.selection.getSelectedCount();
        }
        return selectedCount;
    };

    const editPackageNotification = (notification: JS5Object): void => {
        if (!notification.hidden) {
            $location.url(`/system/packageNotifications/edit/${notification.id}`);
        } else {
            NotificationService.createFailureNotification('Notification is hidden');
        }
    };

    const showConfirmationModal = (action: string, handler: JS5Function): void => {
        let capitalizedAction: string = `${action[0].toUpperCase()}${action.slice(1)}`;
        ModalService.showMessageModal({
                messageText: `Are you sure you want to ${action} the selected notification?`,
                title: capitalizedAction + ' Package Status Notification',
                windowClass: 'confirm-modal-sm',
                showOK: true,
                okText: 'Yes',
                pullCancelLeft: true
            },
            handler
        );
    };

    this.onRowDblClick = (row: JS5Object): void => {
        editPackageNotification(row.entity);
    };

    const initGrid = () => {
        this.gridOptions = {
            rowSelection: true,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            enableSelectAll: false,
            multiSelect: false,
            enableColumnResizing: true,
            enableSorting: true,
            enableHorizontalScrollbar: uiGridConstants.ALWAYS,
            enableVerticalScrollbar: uiGridConstants.ALWAYS,
            rowHeight: 26,
            rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
            onRegisterApi: (gridApi: JS5Object): void => {
                this.gridApi = gridApi;
            }
        };

        this.gridOptions.columnDefs = [
            {
                field: 'status',
                displayName: 'Status',
                width: '15%',
                sort: {
                    direction: 'asc',
                    priority: 0
                },
                cellTemplate: 'system/packageNotifications/searchView/gridTemplates/package-status-cell-template.html'
            },
            {
                field: 'delay',
                displayName: 'Waiting Time',
                width: '10%',
                sort: {
                    direction: 'asc',
                    priority: 1
                },
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                field: 'emailSubjectExpression',
                displayName: 'Email Subject Expression',
                width: '*',
                sort: {
                    direction: 'asc',
                    priority: 3,
                },
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                field: 'emailTemplate.name',
                displayName: 'Email Template',
                width: '20%',
                sort: {
                    direction: 'asc',
                    priority: 3
                },
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                field: 'recipients.length',
                displayName: '# of Recipients',
                width: '10%',
                sort: {
                    direction: 'asc',
                    priority: 2
                },
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            }];
    };

    const initToolbar = () => {
        this.toolbarButtonDefs = [
            {
                label: 'New',
                enabled: () => true,
                onClick: () => $location.url(`/system/packageNotifications/edit/-1`)
            },
            {
                label: 'Edit',
                enabled: () => getSelectedCount() === 1,
                onClick: () => editPackageNotification(this.gridApi.selection.getSelectedRows()[0])
            }
        ];
    };

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        this.gridOptions = undefined;
        this.gridApi = undefined;

        this.toolbarButtonDefs = undefined;

        initGrid();
        initToolbar();

        getData();
    };

}

angular
    .module('prism-ui.packageNotifications')
    .component('packageNotificationsSearchView', {
        bindings: {},
        templateUrl: 'system/packageNotifications/searchView/package-notifications-search-view-template.html',
        controller: PackageNotificationsSearchViewController
    });
